import { createMockStore } from '../../../utils/mockStore';

export const COLLECTIONS = {
  avaliacoes: 'avaliacoes',
  modelos: 'modelos',
  secoes: 'secoes',
  questoes: 'questoes',
  resultados: 'resultados'
};

export const store = createMockStore();

export const ensureError = error => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  const message = error && error.message ? error.message : 'Unknown error';
  return new Error(message);
};

export const isValidPayload = payload =>
  payload !== null && payload !== undefined && typeof payload === 'object' && !Array.isArray(payload);

export const toErrorResult = error => ({
  ok: false,
  data: null,
  error: ensureError(error)
});
